import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="admin--menu-sorter"
export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.initializeExistingLists()
    this.observeMutations()
  }

  initializeExistingLists() {
    const lists = this.element.querySelectorAll(".nested")
    lists.forEach((list) => this.initializeSortable(list))
  }

  initializeSortable(target) {
    if (!target || target.dataset.sortableInitialized === "true") {
      return
    }

    target.dataset.sortableInitialized = "true"

    new Sortable(target, {
      group: "menu-nested",
      animation: 150,
      handle: ".drag-handle",
      fallbackOnBody: true,
      swapThreshold: 0.65,
      onEnd: this.handleEnd.bind(this)
    })
  }

  handleEnd(event) {
    const item = event.item
    const moveUrl = item.dataset.moveUrl

    if (!moveUrl) {
      return
    }

    const parentList = event.to
    const parentId = parentList?.dataset?.id || null
    const position = event.newIndex + 1

    this.updateHierarchy(moveUrl, parentId, position)
  }

  updateHierarchy(url, parentId, position) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({
        parent_id: parentId,
        position: position
      })
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    }).catch((error) => {
      console.error("Error updating menu hierarchy:", error)
      alert("Failed to update menu hierarchy. Please try again.")
    })
  }

  observeMutations() {
    if (!this.hasContainerTarget) {
      return
    }

    this.observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.classList.contains("nested")) {
            this.initializeSortable(node)
          }
        })
      })
    })

    this.observer.observe(this.containerTarget, { childList: true, subtree: true })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
